import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	eyebrow?: TranslationKey;
	heading: TranslationKey;
	body?: TranslationKey;
	align: 'start' | 'center';
}>;

/** The eyebrow / h2 / body stack that opens most of the page's sections. */
export const SectionIntro: React.FC<Props> = ({ eyebrow, heading, body, align }) => {
	return (
		<div className={cn('flex flex-col gap-3', align === 'center' && 'mx-auto max-w-3xl items-center text-center')}>
			{eyebrow && (
				// a label, not a heading: it sits above the h2 and does not open a section of its own
				<Text size="small" className="text-typography-weak font-semibold tracking-wider uppercase">
					<TypedTranslate value={eyebrow} />
				</Text>
			)}
			<Text as="h2" variant="heading" size="large" fontWeight="bold">
				<TypedTranslate value={heading} />
			</Text>
			{body && (
				<Text as="p" variant="body" size="large" className="text-typography-weak">
					<TypedTranslate value={body} />
				</Text>
			)}
		</div>
	);
};
